"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var bhtp_typeahead_directive_1 = require("./bhtp-typeahead.directive");
var Rx_1 = require("rxjs/Rx");
var typeahead_1 = require("@bhtp-client-api/typeahead");
var typeahead_helper_1 = require("./typeahead.helper");
// import { HtmlStripperPipe } from './../shared/common/pipes/pipes.module';
var TYPEAHEAD_VALUE_ACCESSOR = {
    provide: forms_1.NG_VALUE_ACCESSOR,
    useExisting: core_1.forwardRef(function () { return TypeaheadBaseComponent; }),
    multi: true
};
var TypeaheadBaseComponent = (function () {
    function TypeaheadBaseComponent(typeaheadService, zone) {
        var _this = this;
        this.typeaheadService = typeaheadService;
        this.zone = zone;
        this.disabled = false;
        /// set to true if you want exactly what the user typed.
        this.allowGarbage = false;
        this.itemDisplayPropertyName = 'name';
        // an option on the ngx-bootstrap typeahead.
        //  we need this set to true on the get-quote component so the typeahead options can
        //  show over below an element that has overflow:hidden.  Normal cases should be false.
        this.appendToBody = false;
        this.setAutoFocus = false;
        this.typeAheadWaitInMs = 400;
        this.itemSelected = new core_1.EventEmitter(false);
        this.data = [];
        this.typeaheadLoading = false;
        this.typeaheadNoResults = false;
        this.propagateChange = function (_) { };
        this.onTouched = function () { };
        var inputSub = Rx_1.Observable.create(function (observer) {
            _this.inputFeed = observer;
        });
        var cancelSub = Rx_1.Observable.create(function (observer) {
            _this.cancelSearch = observer;
        });
        this.resultsSub = typeaheadService.exchangeSubscription(inputSub, cancelSub);
        this.dataSource = Rx_1.Observable
            .create(function (observer) {
            // Runs on every search
            _this.resultsSub.subscribe(function (result) {
                _this.zone.run(function () {
                    // Only pass in the results if the element is still focused
                    if (_this.typeaheadInput.nativeElement === document.activeElement) {
                        observer.next(result);
                    }
                });
            });
            _this.inputFeed.next(_this.searchValue);
        });
    }
    Object.defineProperty(TypeaheadBaseComponent.prototype, "initialValue", {
        set: function (value) {
            if (value && value[this.itemDisplayPropertyName] && !this.searchValue) {
                this.searchValue = value[this.itemDisplayPropertyName];
                // set the initial value as the previously selected item.
                this.previouslySelectedItem = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    TypeaheadBaseComponent.prototype.ngAfterViewInit = function () {
        if (this.setAutoFocus) {
            this.typeaheadInput.nativeElement.autofocus = this.setAutoFocus;
            this.typeaheadInput.nativeElement.focus();
        }
        if (this.typeaheadService.config && this.typeaheadService.config.isCompatibilityMode && this.typeaheadService.config.isCompatibilityMode()) {
            this.typeaheadDirective.enableCompatibilityMode();
        }
    };
    TypeaheadBaseComponent.prototype.writeValue = function (obj) {
        if (obj && obj[this.itemDisplayPropertyName]) {
            this.searchValue = obj[this.itemDisplayPropertyName];
        }
        else {
            this.searchValue = obj;
        }
        this.previouslySelectedItem = obj;
    };
    TypeaheadBaseComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    TypeaheadBaseComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    TypeaheadBaseComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    TypeaheadBaseComponent.prototype.changeTypeaheadLoading = function (e) {
        this.typeaheadLoading = e;
    };
    TypeaheadBaseComponent.prototype.changeTypeaheadNoResults = function (e) {
        this.typeaheadNoResults = e;
    };
    TypeaheadBaseComponent.prototype.typeaheadOnSelect = function (e) {
        // e is an event, our selected object is in the 'item' property.
        this.onItemSelected(e.item);
    };
    TypeaheadBaseComponent.prototype.typeaheadOnBlur = function (event) {
        this.cancelSearch.next(true);
        this.typeaheadNoResults = false;
        if (!this.searchValue) {
            this.onItemSelected(undefined);
        }
        else if (this.allowGarbage !== true && this.typeaheadDirective._container) {
            // user must select a value (no garbage allowed) and the typeahead container is present.
            // select the active typeahead item.
            this.typeaheadDirective._container.selectActiveMatch();
        }
        else if (this.allowGarbage === true) {
            // if there is a match and the field blurs, select that match. otherwise use what was entered.
            if (this.typeaheadDirective._container && this.typeaheadDirective._container.matches.length > 0) {
                // user clicked item
                this.typeaheadDirective._container.selectActiveMatch();
            }
            else if (this.typeaheadDirective.matches && this.typeaheadDirective.matches.length > 0) {
                // user tabbed out of type ahead
                this.typeaheadDirective.changeModel(this.typeaheadDirective.matches[0]);
                this.onItemSelected(this.typeaheadDirective.matches[0].item);
            }
            else {
                // allow garbage. accept whatever the user types in.
                var item = {};
                item[this.itemDisplayPropertyName] = this.searchValue;
                this.onItemSelected(item);
            }
        }
        else if (this.previouslySelectedItem && (this.searchValue !== null && this.searchValue !== undefined) && typeahead_helper_1.TypeaheadHelper.extractTypeaheadValue(this.previouslySelectedItem, this.itemDisplayPropertyName) === this.searchValue) {
        }
        else {
            // when the item isn't found...
            this.onItemSelected(undefined);
        }
        this.typeaheadDirective.hide();
        this.onTouched();
    };
    TypeaheadBaseComponent.prototype.onItemSelected = function (selectedItem) {
        var shouldPropagate = true;
        if (selectedItem === this.previouslySelectedItem) {
            shouldPropagate = false;
        }
        // store the item locally for tracking.
        this.previouslySelectedItem = selectedItem;
        // if selected item is null, create a new object.
        var returnItem = null;
        if (selectedItem) {
            returnItem = selectedItem;
        }
        else {
            returnItem = {};
            returnItem[this.itemDisplayPropertyName] = '';
        }
        // update the search value to match the value of the item, so focus and blur
        this.searchValue = returnItem[this.itemDisplayPropertyName];
        // pass the selected item/object to subscribers.
        // do not refire 'changed' events when the values are the same.
        if (shouldPropagate) {
            this.itemSelected.emit(selectedItem);
            this.propagateChange(selectedItem);
        }
    };
    return TypeaheadBaseComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], TypeaheadBaseComponent.prototype, "placeHolder", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], TypeaheadBaseComponent.prototype, "disabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], TypeaheadBaseComponent.prototype, "allowGarbage", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], TypeaheadBaseComponent.prototype, "itemDisplayPropertyName", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], TypeaheadBaseComponent.prototype, "appendToBody", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], TypeaheadBaseComponent.prototype, "searchValue", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], TypeaheadBaseComponent.prototype, "setAutoFocus", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], TypeaheadBaseComponent.prototype, "typeAheadWaitInMs", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], TypeaheadBaseComponent.prototype, "initialValue", null);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], TypeaheadBaseComponent.prototype, "itemSelected", void 0);
__decorate([
    core_1.ViewChild(bhtp_typeahead_directive_1.BhtpTypeaheadDirective),
    __metadata("design:type", bhtp_typeahead_directive_1.BhtpTypeaheadDirective)
], TypeaheadBaseComponent.prototype, "typeaheadDirective", void 0);
__decorate([
    core_1.ViewChild('typeaheadInput'),
    __metadata("design:type", Object)
], TypeaheadBaseComponent.prototype, "typeaheadInput", void 0);
TypeaheadBaseComponent = __decorate([
    core_1.Component({
        selector: 'typeahead-custom',
        template: "<div class=\"bhtp-typeahead\">     <input #typeaheadInput class=\"form-control\"             clean-input             placeholder=\"{{placeHolder}}\"             [(ngModel)]=\"searchValue\"             name=\"{{placeHolder}}\"             [bhtpTypeahead]=\"dataSource\"             [typeaheadWaitMs] =\"typeAheadWaitInMs\"             (typeaheadOnSelect)=\"typeaheadOnSelect($event)\"             (typeaheadOnBlur)=\"typeaheadOnBlur($event)\"             (typeaheadNoResults)=\"changeTypeaheadNoResults($event)\"             (typeaheadLoading)=\"changeTypeaheadLoading($event)\"             [typeaheadOptionField]=\"itemDisplayPropertyName\"             [typeaheadOptionsLimit]=\"7\"             [typeaheadMinLength]=\"1\"             [disabled]=\"disabled\"             >     <div class=\"bhtp-typeahead-status\" [hidden]=\"typeaheadLoading!==true\">         <i class=\"glyphicon glyphicon-refresh ng-hide\"></i>     </div>     <div class=\"bhtp-typeahead-status\" [hidden]=\"typeaheadNoResults!==true\">         <i class=\"glyphicon glyphicon-remove\"></i> No Results Found     </div>     <div class=\"bhtp-typeahead-status dropdown-menu\" [hidden]=\"typeaheadLoading !== true\">         Searching {{searchValue}}     </div> </div>",
        providers: [TYPEAHEAD_VALUE_ACCESSOR]
    }),
    core_1.Injectable(),
    __metadata("design:paramtypes", [typeahead_1.BhtpBaseTypeaheadService, core_1.NgZone])
], TypeaheadBaseComponent);
exports.TypeaheadBaseComponent = TypeaheadBaseComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/type-ahead/typeahead-base.component.js